<script setup lang="ts">
const siteConfig = useSiteConfig()

useHead({
  htmlAttrs: {
    lang: 'en',
  },
  link: [
    { href: '/favicon.ico', rel: 'icon', type: 'image/x-icon' },
    { href: '/icon.svg', rel: 'icon', sizes: 'any', type: 'image/svg+xml' },
    { href: '/icon.svg', rel: 'apple-touch-icon', type: 'image/svg+xml' },
  ],
  meta: [
    { content: 'width=device-width, initial-scale=1', name: 'viewport' },
    { content: siteConfig.version, name: 'version' },
    { content: siteConfig.env, name: 'environment' },
  ],
  titleTemplate: titleChunk => {
    return titleChunk && titleChunk !== siteConfig.name ? `${titleChunk} - ${siteConfig.name}` : siteConfig.name
  },
})

useSeoMeta({
  description: siteConfig.description,
  ogDescription: siteConfig.description,
  ogImage: 'https://signalfire.games/icon.svg',
  ogTitle: siteConfig.name,
  ogType: 'website',
  title: siteConfig.name,
  twitterCard: 'summary_large_image',
  twitterImage: 'https://signalfire.games/icon.svg',
})

useSchemaOrg([
  defineWebSite({
    description: siteConfig.description,
    name: siteConfig.name,
  }),
  defineWebPage(),
])
</script>

<template>
  <UApp>
    <NuxtLayout>
      <NuxtPage/>
    </NuxtLayout>
  </UApp>
</template>
